var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-toolbar',{attrs:{"auth-user-id":_vm.userUid,"user-link-name":_vm.agentEmail,"nav-links":_vm.availableLinks,"logo-link":_vm.logoLink},on:{"clicked-sign-out":_vm.signOutUser}})}
var staticRenderFns = []

export { render, staticRenderFns }